import {ResponsiveSunburst} from '@nivo/sunburst'
import {useEffect, useState} from "react";
import {currencyFormat} from "../utils";
import {CenteredMetric} from "./CenteredMetric";
import {findObject, flatten} from "./utils";
import {colors, organizationColors} from '../config';
import {Button} from '@material-ui/core';
import {CommonProperties, SunburstContainer} from "./config";
import './Sunburst.scss';

type SunburstChartProps = {
    data: Array<any>;
    groupBy: string;
    childrenGroupBy?: string;
    title?: string;
    value: string;
    mainKey?: string;
    valueFormat?: string;
    groupByTitle?: string;
    childrenGroupByTitle?: string;
}
const SunburstChart = ({
                           data,
                           groupBy,
                           title,
                           value,
                           valueFormat,
                           childrenGroupBy,
                           mainKey,
                           groupByTitle,
                           childrenGroupByTitle
                       }: SunburstChartProps) => {

    const [drillDownCategory, setDrillDownCategory] = useState('');
    const [chartData, setData] = useState({});
    const [filterredData, setFilterData] = useState({});

    const [calculateWorker, setCalculateWorker] = useState<any>();

    useEffect(() => {
        setCalculateWorker(new Worker(window.location.origin + '/workers/sunburst-worker.js'));
    }, []);

    useEffect(() => {
        if (!calculateWorker) return;
        calculateWorker.onmessage = ($event: MessageEvent) => {
            if ($event && $event.data) {
                setData($event.data.newData);
                setFilterData($event.data.newData);
            }

        };
    }, [calculateWorker]);

    useEffect(() => {
        if (!calculateWorker) return;
        calculateWorker.postMessage({data, groupBy, title, childrenGroupBy, mainKey, value});
    }, [data]);

    const drillDown = (clickedData: any) => {
        // @ts-ignore
        const newData = findObject(flatten(filterredData.children), clickedData.id);

        if (newData && newData.children) {
            setFilterData(newData);
            setDrillDownCategory(clickedData.id);
        }
    }

    const ResetButton = () => {

        if (drillDownCategory) {
            return (
                <Button variant="outlined"
                        aria-label="cofnij"
                        color="primary"
                        onClick={() => {
                            setFilterData(chartData);
                            setDrillDownCategory('');
                        }}>Cofnij</Button>
            )
        } else {
            return (
                <div>
                    <p className={"seeMore"}>Kliknij by zobaczyć szczegóły</p>
                </div>
            )
        }
    }

    return (
        <div className="container chart sunburst">
            <h3>{(title || groupBy) + (drillDownCategory ? ` - ${drillDownCategory}` : '')}</h3>
            <div style={{height: SunburstContainer.height}}>
                <ResponsiveSunburst
                    {...CommonProperties}
                    data={filterredData}
                    valueFormat={valueFormat === 'currency' ? currencyFormat : (value: any) => value}
                    childColor={{from: 'color', modifiers: [['brighter', .5]]}}
                    layers={['arcs', 'arcLabels', ({nodes, centerX, centerY}) => CenteredMetric({
                        nodes,
                        centerX,
                        centerY,
                        valueFormat
                    })]}
                    enableArcLabels
                    arcLabelsSkipAngle={30}
                    borderWidth={2}
                    colors={groupBy === 'organization' ? ({id}) => {
                        // @ts-ignore
                        return organizationColors[id] as string;
                    } : colors}
                    arcLabelsTextColor={{from: 'color', modifiers: [['darker', 3]]}}
                    onClick={drillDown}
                    value={'value'}
                    id={'name'}
                />
            </div>
            <div className="function-buttons">
                <div className="sunburstLegend">
                    <p>Wewnętrzny pierścień: <span className="sunburstLegend__value">{groupByTitle}</span></p>
                    <p>Zewnętrzny pierścień: <span className="sunburstLegend__value">{childrenGroupByTitle}</span></p>
                </div>
                {ResetButton()}</div>
        </div>
    );
}
export {SunburstChart};
